<template>
    <div class="h-full border-l border-gray-300 bg-gray-50">
        Data Request Bulk Ops
    </div>
</template>

<script setup>
</script>